const sameFeeType = (left, right) => String(left) === String(right);

export const getFocusedSessionIdsFromStoredFees = ({
  additionalFees = [],
  zeroPayments = [],
  accompanyingPersonFee,
}) => {
  if (!accompanyingPersonFee) {
    return [];
  }

  const focusedSessionsFromAdditionalFees = additionalFees
    .filter(
      (fee) =>
        !sameFeeType(fee.feeTypeId, accompanyingPersonFee.id) && !fee.paymentId
    )
    .map((fee) => fee.feeTypeId);

  const focusedSessionsFromZeroPayments = zeroPayments
    .filter(
      (zeroPayment) =>
        !sameFeeType(zeroPayment.feeTypeId, accompanyingPersonFee.id)
    )
    .map((zeroPayment) => zeroPayment.feeTypeId);

  return [
    ...new Set([
      ...focusedSessionsFromAdditionalFees,
      ...focusedSessionsFromZeroPayments,
    ]),
  ];
};
